module.exports = __webpack_public_path__ + "img/retail08.c87fbd8c.png";